import { PostsService } from '@/service'
import Model from './Model'

export interface IPosts {
  _id?: string
  locationId: string
  visibility?: string
  channelId: string
  groupId: string
  title: string
  content: string
  attachments?: []
  mentions: Array<{ contactId: string }>
  thumbnailUrl?: string
  createdBy?: string
  reactionType?: Map<string, number>
  channelPinnedIndex?: number
  homePinnedIndex?: number
  commentsCount?: number
  commentsAvatarGroupOption?: { [key: string]: any }
  relativeTime?: string
  [key: string]: any
}

export default class Posts extends Model {
  constructor(payload: IPosts) {
    super(payload, PostsService)
  }

  get locationId(): string {
    return this._data.locationId
  }

  set locationId(locationId: string) {
    this._data.locationId = locationId
  }

  get relativeTimelocationId(): string {
    return this._data.relativeTime
  }

  set relativeTime(relativeTime: string) {
    this._data.relativeTime = relativeTime
  }

  get commentsAvatarGroupOption(): [] {
    return this._data.commentsAvatarGroupOption
  }

  set commentsAvatarGroupOption(commentsAvatarGroupOption: []) {
    this._data.commentsAvatarGroupOption = commentsAvatarGroupOption
  }

  get commentsCount(): number {
    return this._data.commentsCount
  }

  set commentsCount(commentsCount: number) {
    this._data.commentsCount = commentsCount
  }
  get visibility(): string {
    return this._data.visibility
  }

  set visibility(visibility: string) {
    this._data.visibility = visibility
  }

  get channelId(): string {
    return this._data.channelId
  }

  set channelId(channelId: string) {
    this._data.channelId = channelId
  }

  get title(): string {
    return this._data.title
  }

  set title(title: string) {
    this._data.title = title
  }

  get content(): string {
    return this._data.content
  }

  set content(content: string) {
    this._data.content = content
  }

  get attachments(): [] | undefined {
    return this._data.attachments
  }

  set attachments(attachments: [] | undefined) {
    this._data.attachments = attachments
  }

  get mentions(): [] {
    return this._data.mentions
  }

  set mentions(mentions: []) {
    this._data.mentions = mentions
  }

  get thumbnailUrl(): string | undefined {
    return this._data.thumbnailUrl
  }

  set thumbnailUrl(thumbnailUrl: string | undefined) {
    this._data.thumbnailUrl = thumbnailUrl
  }

  get createdBy(): string {
    return this._data.createdBy
  }

  set createdBy(createdBy: string) {
    this._data.createdBy = createdBy
  }

  get reactionType(): Map<string, number> | undefined {
    return this._data.reactionType
  }

  set reactionType(reactionType: Map<string, number> | undefined) {
    this._data.reactionType = reactionType
  }

  get isPinned(): boolean | undefined {
    return this._data.isPinned
  }

  set isPinned(isPinned: boolean | undefined) {
    this._data.isPinned = isPinned
  }
}
